import { call, put, select, takeLatest } from 'redux-saga/effects'
import { ISpecialReportsState, ISpecialReport } from '../store/specialReports.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getPcrIdSelector } from '../../home/selectors'
import { getSpecialReportsSelector } from '../selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { SpecialReportsConstants } from '../store/specialReports.constants'
import { setSpecialReportsList } from '../store/specialReports.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getServiceIdSelector } from '../../user/selectors'

export function* deleteSpecialReport() {
  const specialReportsState: ISpecialReportsState = yield select(getSpecialReportsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const { __deleteSpecialReportId, specialReportsList } = specialReportsState

  if (!pcrID || !__deleteSpecialReportId) {
    return
  }

  try {
    const newSpecialReportsList = specialReportsList.filter(
      (report: ISpecialReport) => report.id !== __deleteSpecialReportId
    )
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      _specialReports: newSpecialReportsList,
    }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)

    yield put(setSpecialReportsList(newSpecialReportsList))
  } catch (e) {
    yield put(throwPcrException(`deleteSpecialReport() error: ${e}`))
  }
}

export function* deleteSpecialReportSaga() {
  yield takeLatest([SpecialReportsConstants.DELETE_SPECIAL_REPORT], performWithMutexHOG, deleteSpecialReport)
}
